import { IPNLSubTabs } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { FilterTabEnum } from "@frameworks/web/components/Reports/CommonComponent/constant";
export const getPNLSubHeadingName = (PNLSubTabName) => {
    switch (PNLSubTabName) {
        case IPNLSubTabs.EQUITY:
            return FilterTabEnum.EQUITY;
        case IPNLSubTabs.FIXED_INCOME:
            return FilterTabEnum.FI;
        case IPNLSubTabs.DERIVATIVE:
            return FilterTabEnum.DERIVATIVE;
        case IPNLSubTabs.MANAGED_PORTFOLIO:
            return FilterTabEnum.MP;
        case IPNLSubTabs.OTHERS:
            return FilterTabEnum.OTHERS;
        default:
            return FilterTabEnum.EQUITY;
    }
};
